import React, { createContext, useState, useCallback } from 'react';

interface GlobalSpinnerContextType {
  isSpinning: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
}

export const GlobalSpinnerContext = createContext<GlobalSpinnerContextType | undefined>(undefined);

export function GlobalSpinnerProvider({ children }: { children: React.ReactNode }) {
  const [isSpinning, setIsSpinning] = useState(false);

  const showSpinner = useCallback(() => {
    setIsSpinning(true);
  }, []);

  const hideSpinner = useCallback(() => {
    setIsSpinning(false);
  }, []);

  return (
    <GlobalSpinnerContext.Provider value={{ isSpinning, showSpinner, hideSpinner }}>
      {children}
      {isSpinning && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/10 backdrop-blur-sm transition-opacity">
          <div className="w-14 h-14 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      )}
    </GlobalSpinnerContext.Provider>
  );
}
